<template>
  <el-main>
    <query-gather :is-add="authorityMap.isAdd" :is-input="false" :is-query="false" :is-reset="false"
                  :cur-input-tip="curInputTip"
                  :is-date-nf="true"
                  @qgDateNfSelectDeal="qgQuery"
                  style="margin-top: -2vh"
                  @qgAddDeal="addItemDeal"></query-gather>
    <div class="commonDiv">
      <el-table
          :data="sprvTableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          border
          ref="sprvTableRef"
          size="mini"
          @selection-change="tableSelectionChange"
          @sort-change="sprvSortChange"
          :row-style="tableRowClassName"
          max-height="calc(100% - 60px)"
          style="width: 100%;"
          height="calc(100% - 60px)"
          :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.6rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}">
        <template v-for="(item,index) in sprvTitles">
          <template v-if="index ===0">
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip>
              <template slot-scope="scope">
                <a style="color: #46adf5; cursor: pointer;"
                   @click="sprvClickDeal(scope.row)">{{ scope.row.dy }}</a>
              </template>
              <template v-for="(child,index) in item.children" v-show="item.children">
                <el-table-column
                    :prop="child.prop"
                    :width="child.width"
                    :label="child.label"
                    :align="child.align"
                    :sortable="child.sortable"
                    show-overflow-tooltip
                ></el-table-column>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip
            >
              <template v-for="(child,index) in item.children" v-show="item.children">
                <el-table-column
                    :prop="child.prop"
                    :width="child.width"
                    :label="child.label"
                    :align="child.align"
                    :sortable="child.sortable"
                    show-overflow-tooltip
                ></el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
        <el-table-column label="操作" align="center" width="100" v-if="authorityMap.isDel">
          <template slot-scope="scope">
            <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
              <el-popconfirm
                  title="确定删除吗？"
                  @confirm="sprvItemDeleteDeal(scope.row)"
              >
                <img
                    src="~@/assets/images/operates/delete.png"
                    alt=""
                    slot="reference"
                    style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <!--      <div class="commonPage2">
              <el-pagination
                  @size-change="sprvHandleSizeChange"
                  @current-change="gzHandleCurrentChange"
                  :page-sizes="[10, 20, 30]"
                  :page-size="params.size"
                  :current-page="params.current"
                  layout="total, prev, pager, next,sizes, jumper"
                  background
                  :total="params.total"
              >
              </el-pagination>
            </div>-->
    </div>
    <data-dialog :dialog-title="sprvDialog.title" :is-visible="sprvDialog.sprvFormVisible" :is-read="isRead"
                 @dgVerifyDeal="dgVerifyDeal('sprvDialog','dialog')" ref="sprvDialog" @dgConfirmDeal="dgsprvConfirmDeal"
                 @dgCancelDeal="dgCancelDeal">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="sprvDialog.data" :rules="sprvRules" label-width="100px"
                 :disabled="isRead"
                 class="commonForm">
          <div>
            <el-form-item label="年份" prop="dy" style="margin-left: -2vw;">
              <el-date-picker
                  v-model="sprvDialog.data.dy"
                  type="year"
                  size="small"
                  value-format="yyyy"
                  placeholder="请选择年份">
              </el-date-picker>
            </el-form-item>
          </div>
          <div style="background-color: #FBFBFB;padding: 2vh;margin-right: 2vw;">
            <div>行政责任人</div>
            <el-row style="margin-top: 1vh;">
              <el-col :span="12">
                <el-form-item label="姓名" prop="xzName" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xzName']" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位" prop="xzDept" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xzDept']" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="职务" prop="xzZw" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xzZw']" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" prop="xzSj" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xzSj']" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div style="background-color: #FBFBFB;padding: 2vh;margin-right: 2vw;margin-top: 2vh;">
            <div>技术责任人</div>
            <el-row style="margin-top: 1vh;">
              <el-col :span="12">
                <el-form-item label="姓名" prop="jsName" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['jsName']" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位" prop="jsDept" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['jsDept']" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="职务" prop="jsZw" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['jsZw']" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" prop="jsSj" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['jsSj']" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div style="background-color: #FBFBFB;padding: 2vh;margin-right: 2vw;margin-top: 2vh;">
            <div>巡查责任人</div>
            <el-row style="margin-top: 1vh;">
              <el-col :span="12">
                <el-form-item label="姓名" prop="xcName" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xcName']" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位" prop="xcDept" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xcDept']" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="职务" prop="xcZw" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xcZw']" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" prop="xcSj" style="width: 90%;">
                  <el-input v-model="sprvDialog.data['xcSj']" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </data-dialog>
  </el-main>
</template>

<script>
import BottomPagination from "../../components/tableGather/bottomPagination";
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";

/**
 * @Author: ygh
 * @Date: 2024/5/22 15:31
 * @Description:责任人信息管理页面
 */
export default {
  name: "sprv",
  mounted() {
    this.initSprvData();
  },
  components: {BottomPagination, DataDialog, QueryGather},
  data() {
    let mobilephoneRules = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        const reg = /^1[3-9]\\d{9}$|/;
        if (reg.test(value)) {
          value = value + '';
          if (value.length > 11) {
            return callback(new Error("手机号码最多11位"));
          }
          callback();
        } else {
          return callback(new Error("手机号码格式错误"));
        }
      }
    };
    let validateMcLen = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length > 30) {
          return callback(new Error("长度不能超过30个字符"));
        } else {
          return callback();
        }
      }
    };

    return {
      authorityMap: {
        isAdd: false,//新增权限
        isUpdate: false,//修改权限
        isDel: false,//删除权限
        isView: false,//查看权限
      },
      isRead: false,
      isAddData:false,
      stRemHeight: 0,
      curInputTip: '请输入姓名或者联系方式',
      staffDataArr: [],
      sprvTitles: [
        {
          prop: 'dy', label: '年份', width: null, align: 'center', sortable: true,
        },
        {
          prop: 'xz', label: '行政责任人', width: null, align: 'left', sortable: false,
          children: [
            {
              prop: 'xzName', label: '姓名', width: null, align: 'center', sortable: false,
            }, {
              prop: 'xzDept', label: '单位', width: null, align: 'center', sortable: false,
            }, {
              prop: 'xzZw', label: '职务', width: null, align: 'center', sortable: false,
            }, {
              prop: 'xzSj', label: '联系方式', width: null, align: 'center', sortable: false,
            },
          ],
        },
        {
          prop: 'js', label: '技术责任人', width: null, align: 'left', sortable: false,
          children: [
            {
              prop: 'jsName', label: '姓名', width: null, align: 'center', sortable: false,
            }, {
              prop: 'jsDept', label: '单位', width: null, align: 'center', sortable: false,
            }, {
              prop: 'jsZw', label: '职务', width: null, align: 'center', sortable: false,
            }, {
              prop: 'jsSj', label: '联系方式', width: null, align: 'center', sortable: false,
            },
          ],
        },
        {
          prop: 'xc', label: '巡查责任人', width: null, align: 'left', sortable: false,
          children: [
            {
              prop: 'xcName', label: '姓名', width: null, align: 'center', sortable: false,
            }, {
              prop: 'xcDept', label: '单位', width: null, align: 'center', sortable: false,
            }, {
              prop: 'xcZw', label: '职务', width: null, align: 'center', sortable: false,
            }, {
              prop: 'xcSj', label: '联系方式', width: null, align: 'center', sortable: false,
            },
          ],
        },
      ],
      sprvTableData: [],
      sprvRules: {
        dy: [
          {required: true, message: "请选择年份", trigger: "blur"},
        ],
        xzName: [
          {required: true, message: "请输入姓名", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xzDept: [
          {required: true, message: "请输入单位", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xzZw: [
          {required: true, message: "请输入职务", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xzSj: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
          {validator: mobilephoneRules, trigger: 'blur'},
        ],
        jsName: [
          {required: true, message: "请输入姓名", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        jsDept: [
          {required: true, message: "请输入单位", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        jsZw: [
          {required: true, message: "请输入职务", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        jsSj: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
          {validator: mobilephoneRules, trigger: 'blur'},
        ],
        xcName: [
          {required: true, message: "请输入姓名", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xcDept: [
          {required: true, message: "请输入单位", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xcZw: [
          {required: true, message: "请输入职务", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xcSj: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
          {validator: mobilephoneRules, trigger: 'blur'},
        ],
      },
      params: {
        total: 1,
        size: 10,
        current: 1,
      },
      sprvOrder: 1,
      loading: false,
      sprvMultiple: true,
      sprvMultipleSelection: [],
      curSelectDateNf: '',
      sprvDialog: {
        title: "",
        sprvFormVisible: false,
        data: {
          "dy": "",
          "xzName": "",
          "xzDept": "",
          "xzZw": "",
          "xzSj": "",
          "jsName": "",
          "jsDept": "",
          "jsZw": "",
          "jsSj": "",
          "xcName": "",
          "xcDept": "",
          "xcZw": "",
          "xcSj": "",
        },
      },
      dialogData: {
        "dy": "",
        "xzName": "",
        "xzDept": "",
        "xzZw": "",
        "xzSj": "",
        "jsName": "",
        "jsDept": "",
        "jsZw": "",
        "jsSj": "",
        "xcName": "",
        "xcDept": "",
        "xcZw": "",
        "xcSj": "",
      },
    }
  },
  created() {
    let windowHeight =
        document.documentElement.clientHeight || document.bodyclientHeight;
    this.stRemHeight = windowHeight / 100;
  },
  methods: {
    initSprvData() {
      this.pageAuthorityDeal();
      this.getSprvData();
    },
    pageAuthorityDeal() {
      const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
      const qx = thirdAuthority[this.$route.name];
      if (qx === 'all' || qx === null) {
        this.authorityMap.isAdd = true;
        this.authorityMap.isDel = true;
        this.authorityMap.isUpdate = true;
        this.authorityMap.isView = true;
      } else {
        this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
        this.authorityMap.isDel = qx.indexOf('删除') !== -1;
        this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
        this.authorityMap.isView = qx.indexOf('查询') !== -1;
      }
      // console.log("当前页面三级菜单权限", thirdAuthority, this.authorityMap);
    },
    dgCancelDeal() {
      if (this.sprvDialog.sprvFormVisible) {
        this.sprvDialog.sprvFormVisible = false;
        this.$refs['dialog'].clearValidate();
      }
    },
    dgsprvConfirmDeal() {
      this.isRead = false;
      if (this.isAddData) {
        this.addSprv();
      } else {
        this.updateSprv();
      }
    },
    dgVerifyDeal(dgRef, frRef) {
      this.$refs[frRef].validate((valid) => {
        if (valid) {
          this.$refs[dgRef].isShowPop(true);
        } else {
          this.$refs[dgRef].isShowPop(false);
        }
      });
    },
    addSprv() {
      this.request.post('/rm-pspvr/addSpvr', this.sprvDialog.data).then(res => {
        if (res.ok) {
          this.sprvDialog.sprvFormVisible = false;
          this.sprvDialog.data = {};
          this.isAddData = false;
          this.$message.success('成功添加责任人信息');
          this.getSprvData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    updateSprv() {
      // console.log("======updateSprv======", this.sprvDialog.data);
      this.request.post('/rm-pspvr/modifySpvr', this.sprvDialog.data).then(res => {
        if (res.ok) {
          this.sprvDialog.sprvFormVisible = false;
          this.sprvDialog.data = {};
          this.isAddData = false;
          this.$message.success('成功修改责任人信息');
          this.getSprvData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    resetSprvDataDeal() {
      this.curSelectDateNf = '';
      this.sprvOrder = 1;
      this.clearTableStatus();
      this.getSprvData();
    },
    clearTableStatus() {
      this.$refs.sprvTableRef.clearSort();
    },
    initGetSprvData() {
      this.params = {
        total: 0,
        size: 10,
        current: 1,
      };
      this.getSprvData();
    },
    qgQuery(params) {
      this.curSelectDateNf = params.curSelectDateNf !== null ? params.curSelectDateNf : '';
      this.sprvOrder = 1;
      this.clearTableStatus();
      this.getSprvData();
    },
    addItemDeal() {
      this.sprvDialog.title = '新增责任人信息';
      this.sprvDialog.sprvFormVisible = true;
      this.sprvDialog.data = {...this.dialogData};
      this.isAddData = true;
      this.isRead = false;
      // console.log("======addItemDeal======", this.sprvDialog, this.btnIndex);
    },
    sprvItemDeleteDeal(row) {
      this.request.delete('/rm-pspvr/v1/' + row['id']).then(res => {
        if (res.ok) {
          this.$message.success("数据删除成功");
          this.initGetSprvData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    sprvSortChange(column) {
      this.sprvOrder = column.order === "descending" ? 1 : 0;
      this.getSprvData();
    },
    tableSelectionChange(val) {
      this.sprvMultiple = !val.length;
      this.sprvMultipleSelection = val;
    },
    sprvClickDeal(row) {
      if (this.authorityMap.isView || this.authorityMap.isUpdate) {
        this.isAddData = false;
        this.setSprvDataToDialog(row);
      }
    },
    setSprvDataToDialog(row) {
      this.sprvDialog.title = '修改责任人信息'
      this.sprvDialog.sprvFormVisible = true;
      this.isRead = this.authorityMap.isView && !this.authorityMap.isUpdate;
      this.sprvDialog.data = {};
      this.sprvDialog.data = {...row};
      // console.log("======sprv======", this.sprvDialog.data);
    },
    tableRowClassName({row, rowIndex}) {
      return {
        backgroundColor: '#ffffff',
        fontSize: '1.4rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#616f7b',
        height: '5.83vh',
      };
    },
    sprvHandleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1;
    },
    //切换页码
    gzHandleCurrentChange(val) {
      this.params.current = val;
      // this.getStationData();
    },
    getSprvData() {
      this.loading = true;
      let params = {
        order: this.sprvOrder,
        dy: this.curSelectDateNf + '',
      };
      this.request.get('/rm-pspvr/querySpvrList', {params: params}).then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.sprvTableData = res.data;
            // console.log(res, '===getSprvDataRes===', this.sprvTableData);
          } else {
            this.$message.info("获取责任人信息数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
        this.loading = false;
      });
    },
  },
  watch: {
    "$store.state.head.skCd"() {
      this.resetSprvDataDeal();
    }
  }

}
</script>

<style scoped>
.commonForm {
  padding-top: 4vh;
  padding-left: 6vh;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 200px);
}

/deep/ .el-pagination {
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}

.commonPage2 {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}


</style>

